module.exports = __webpack_public_path__ + "img/clinical-symptoms-reported-image-1.4e9d1fbc.png";